export const globalActionTypes = {
    GLOBAL_ERROR: 'GLOBAL_ERROR'
}